import { http, HttpResponse } from 'msw'

import { allMicrowaves } from 'app/mocks/data/machines/microwaves'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersMicrowaveApi } from 'app/utils/machines/microwave'

import { MicrowavesRequest } from 'app/types/machines/microwave'

export const getAllMicrowaves = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.microwaves.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get(
            searchParametersMicrowaveApi.MANAGERS,
        )

        const clientIdsFilter = searchParams.get(
            searchParametersMicrowaveApi.CLIENTS,
        )

        const siteIdsFilter = searchParams.get(
            searchParametersMicrowaveApi.SITES,
        )

        const microwaveIdsFilter = searchParams.get(
            searchParametersMicrowaveApi.IDs,
        )

        const nameFilter = searchParams.get(searchParametersMicrowaveApi.NAME)

        let allMicrowavesFiltered = allMicrowaves

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allMicrowavesFiltered = allMicrowavesFiltered.filter((microwave) =>
                managerIdsSplit.includes(
                    microwave.site.customer_name.client.id,
                ),
            )
        }

        // Client filter
        if (clientIdsFilter) {
            const clientIdsSplit = queryIntoArrayNumber(clientIdsFilter)

            allMicrowavesFiltered = allMicrowavesFiltered.filter((microwave) =>
                clientIdsSplit.includes(microwave.site.customer_name.id),
            )
        }

        // Site filter
        if (siteIdsFilter) {
            const siteIdsSplit = queryIntoArrayNumber(siteIdsFilter)

            allMicrowavesFiltered = allMicrowavesFiltered.filter((microwave) =>
                siteIdsSplit.includes(microwave.site.id),
            )
        }

        // Microwave ID filter
        if (microwaveIdsFilter) {
            const microwaveIdsSplit = queryIntoArrayNumber(microwaveIdsFilter)

            allMicrowavesFiltered = allMicrowavesFiltered.filter((microwave) =>
                microwaveIdsSplit.includes(microwave.id),
            )
        }

        // Name filter
        if (nameFilter) {
            allMicrowavesFiltered = allMicrowavesFiltered.filter((microwave) =>
                microwave.name.toLowerCase().includes(nameFilter.toLowerCase()),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allMicrowavesFiltered.length > limit
                ? offset + limit
                : allMicrowavesFiltered.length

        const results = allMicrowavesFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allMicrowavesFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<MicrowavesRequest>({
            next,
            results,
        })
    },
)
